import { OnboardingStatus } from '../components/PhoneOnboarding/phoneOnboardingApi';
import { isLoggedIn } from '../utils/helpers';
import { UserInfo } from '../utils/types';

export type AuthenticationResolution =
  | { state: 'authenticated' }
  | { state: 'phone_verification_required'; expiresAt: string }
  | { state: 'unauthenticated' };

type Inputs = {
  userInfo: UserInfo | null;
  eeMode: boolean;
  getOnboardingStatus: () => Promise<OnboardingStatus>;
};

export const resolveAuthenticationState = async ({
  userInfo,
  eeMode,
  getOnboardingStatus,
}: Inputs): Promise<AuthenticationResolution> => {
  if (isLoggedIn(userInfo)) {
    return { state: 'authenticated' };
  }

  if (eeMode) {
    return { state: 'unauthenticated' };
  }

  try {
    const onboardingStatus = await getOnboardingStatus();
    return onboardingStatus.status === 'verification_required'
      ? {
          state: 'phone_verification_required',
          expiresAt: onboardingStatus.expiresAt,
        }
      : { state: 'unauthenticated' };
  } catch {
    return { state: 'unauthenticated' };
  }
};
